// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#back_clean_btn[data-v-4275439c]:before {\n  background-color: transparent !important;\n}", ""]);
// Exports
module.exports = exports;
